import { ChangeDetectionStrategy, Component, ElementRef, inject, model } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Chips } from '@modules/filter/services/filter-chips/filter-chips.service';

@Component({
  selector: 'app-f-chips-item',
  imports: [MatIconModule],
  templateUrl: './f-chips-item.component.html',
  styleUrl: './f-chips-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FChipsItemComponent {
  item = model.required<Chips>();

  host = inject(ElementRef).nativeElement;
}
